import { TicketItem } from 'shared/models/ticket'

export const getIdPassportAvailable = (
  ticket?: TicketItem | null,
  availableList?: string[],
) => {
  const listFlights: string[] = []

  ticket?.segments?.forEach((item) => {
    listFlights.push(item.dep.airport.code)
    listFlights.push(item.arr.airport.code)
  })

  const setAvailable = new Set(availableList)
  const setListFlight = new Set(listFlights)

  const difference = [...setListFlight].filter((x) => !setAvailable.has(x))

  return difference?.length === 0
}
